export default {
  public: {
    loading: "جار التحميل...",
    ok: "موافق",
    cancel: "إلغاء",
    back: "رجوع",
    userDefined: "مخصص",
    edit: "التعديل",
    clear: "واضح",
    delete: "احذف",
    close: "يغلق",
    remove: "إزالة",
    preView: "معاينة",
    systemMsg: "معلومة",
    sourceInvalid: "مصدر البيانات غير صالح، يرجى المحاولة مرة أخرى.",
    replace: "يستبدل",
    generateSuccess: "تم إنشاء عرض PowerPoint التقديمي بنجاح!",
    templateChoose: "اختر قالبًا لإكمال إنشاء الذكاء الاصطناعي الخاص بك",
    templateChooseShort: "اختر قالب الشريحة",
    templateChangeTips:
      "سيؤدي استبدال بيانات القالب إلى إعادتها إلى محتواها الأصلي. سيتم فقدان المحتوى المعدل. هل أنت متأكد أنك تريد الاستمرار؟",
    systemBusy: "الخادم مشغول، يرجى تحديث الصفحة.",
    templateReplaceSuccess:
      "تم استبدال القالب بنجاح. يرجى الحفظ يدويًا، لأن النظام لن يقوم بالحفظ تلقائيًا.",
    shareLinkTips: "تم النسخ بنجاح، جاري إعادة توجيه صفحة الويب الآن!",
    noPermissionTips:
      "عذرًا، تم إغلاق إذن مشاركة هذا العرض التقديمي من قبل المؤلف~ يمكنك تسجيل الدخول إلى aippttv، واستعراض خيالك، وإنشاء العرض التقديمي الخاص بك!",
    copyTips: "تم النسخ بنجاح!",
    loginTips: "الرجاء تسجيل الدخول أولاً!",
    bottomTag: "صُنع باستخدام {brand}",
    fontType: {
      Arial: "Arial",
      "Microsoft Yahei": "Microsoft YaHei",
      SimSun: "SimSun",
      SimHei: "SimHei",
      KaiTi: "KaiTi",
      NSimSun: "NSimSun",
      FangSong: "FangSong",
      "PingFang SC": "PingFang",
      STHeiti: "STHeiti",
      STKaiti: "STKaiti",
      STSong: "STSong",
      STFangSong: "STFangsong",
      STZhongSong: "STZhongsong",
      STHupo: "STHupo",
      STXinwei: "STXinwei",
      STLiti: "STLiti",
      STXingkai: "STXingkai",
      "Hiragino Sans GB": "Hiragino Sans",
      "Lantinghei SC": "Lantinghei",
      "Hanzipen SC": "Pianpian",
      "Hannotate SC": "Shouzhati",
      "Songti SC": "Songti",
      "Wawati SC": "Wawati",
      "Xingkai SC": "Xingkai",
      "Yuanti SC": "Yuanti",
      STXihei: "STXihei",
      YouYuan: "Youyuan",
      LiSu: "Lishu",
    },
    font: {
      font: "الخط",
      sysFont: "الخط النظام",
      lineFont: "الخطوط على الانترنت",
      fontColor: "لون الخط",
      textColor: "لون الخط",
      fontDelay: "تسليط الضوء على النص",
      addSize: "زيادة حجم الخط",
      duceSize: "إنقاص حجم الخط",
      left: "محاذاة لليسار",
      middle: "مركز",
      horizontalCenter: "المركز الأفقي",
      verticalCenter: "المركز العمودي",
      right: "محاذاة لليمين",
      bottom: "محاذاة أسفل",
      top: "محاذاة أعلى",
      bold: "غامق",
      em: "مائل",
      underline: "تحته خط",
      strikethrough: "يتوسطه خط",
      richText: "تنسيق واضح",
      textFormat: "فرشاة التنسيق",
      addIndex: "زيادة المسافة البادئة",
      duceIndex: "إنقاص المسافة البادئة",
      no: "الترقيم",
      link: "ارتباط تشعبي",
      inputLink: "أدخل الارتباط التشعبي",
      superscript: "مرتفع",
      subscript: "سفلي",
      code: "رمز مضمن",
      blockquote: "اقتبس",
      horizontal: "أفقي",
      vertical: "عمودي",
      width: "الاتساع",
      height: "الارتفاع",
      rotate: "استدارة",
      uniformHorizontal: "توزيع أفقيا",
      uniformVertical: "توزيع عموديا",
      combine: "الجمع بين",
      unCombine: "فك التجميع",
      bgColor: "لون الخلفية",
      mainColor: "لون السمة",
      useMainToAll: "تطبيق السمة على الكل",
      preMain: "موضوع محدد مسبقا",
    },
    specialEffects: {
      useAll: "تنطبق على الكل",
      no: "لا شيء",
      fade: "تتلاشى داخل/خارج",
      slideX: "حرك لليسار/لليمين",
      slideY: "حرك لأعلى/لأسفل",
    },
  },
  chart: {
    insertCol: "إدراج عمود",
    insertRow: "إدراج صف",
    delCol: "حذف العمود",
    delRow: "حذف الصف",
    merCell: "دمج الخلايا",
    unMerCell: "فصل الخلايا",
    selectCurrentCol: "تحديد العمود الحالي",
    selectCurrentRow: "تحديد الصف الحالي",
    selectAll: "تحديد كل الخلايا",
    toTheLeft: "إلى اليسار",
    toTheRight: "إلى اليمين",
    toTheTop: "إلى الأعلى",
    toTheBottom: "إلى الأسفل",
  },
  desktop: {
    fileExportSuccess: "تم تصدير الملف بنجاح. حدد موقعًا لحفظ الملف",
    unSupportPreviewPDF:
      "لا تتوفر معاينة PDF هنا. إذا كنت تريد المعاينة، يرجى الانتقال إلى الموقع الرسمي للكمبيوتر الشخصي.",
  },

  extension: {
    nonsupportDownloadPDF:
      "لا يدعم إضافة المتصفح تنزيل ملف PDF ، يرجى الانتقال إلى الموقع الرسمي للتنزيل",
  },
  index: {
    createText: "توليد محتوى PPT",
    createPage: "إنشاء المحتوى للصفحة {0}",
    haveProblem: "لدي مشكلة",
    systemError: "{0}",
    saveText: "تم الحفظ بنجاح",
    saveMessage: "هل أنت متأكد من الحفظ؟",
    cBtn: "إلغاء",
    sBtn: "موافق",
    waitMsg:
      "يرجى التحلي بالصبر والانتظار لمدة 30-40 ثانية. إذا لم يتم إنشاؤه، يرجى تحديث المتصفح الخاص بك والمحاولة مرة أخرى!",
  },
  errorCode: {
    401: "فشلت المصادقة، غير قادر على الوصول إلى موارد النظام",
    403: "العملية الحالية غير مسموح بها",
    404: "الموارد غير موجود",
    default: "خطأ غير معروف في النظام، يرجى إبلاغ المسؤول",
    notReDo: "تتم معالجة البيانات، يرجى عدم إعادة الإرسال.",
    loginMsg:
      "جلسة غير صالحة أو انتهت صلاحية الجلسة. الرجاد الدخول على الحساب من جديد.",
    errMsg: "النظام مشغول، يرجى المحاولة مرة أخرى في وقت لاحق.",
  },
  linkHandler: {
    pptPage: "صفحة الشريحة",
    change: "تغيير",
    remove: "يزيل",
  },
  editor: {
    ctrlV: "معجون",
    ctrlA: "اختر الكل",
    enter: "صفحة جديدة",
    f5: "عرض شرائح",
    delete: "حذف الصفحة",
    ctrlD: "صفحة مكررة",
    ctrlX: "قص",
    ctrlC: "ينسخ",
    shiftF5: "ابدأ من الحالي",
    positionPanel: {
      horizontalCenter: "مركز أفقي",
      verticalCenter: "مركز عمودي",
      horizontalVerticalCenter: "مركز أفقي وعمودي",
      left: "محاذاة لليسار",
      right: "محاذاة لليمين",
      top: "محاذاة للأعلى",
      bottom: "محاذاة للأسفل",
      onTop: "وضع في الأعلى",
      onBottom: "وضع في الأسفل",
      levelUp: "تحريك مستوى واحد للأعلى",
      levelDown: "تحريك مستوى واحد للأسفل",
      setLink: "تعيين رابط",
      ungroup: "إلغاء التجميع",
      group: "تجميع",
      selectAll: "تحديد الكل",
      lock: "قفل",
      unlock: "فتح",
      delete: "حذف",
    },
    canvas: {
      index: {
        ctrlR: "المسطرة",
        ctrlW: "خطوط الشبكة",
        nl: "لا شيء",
        small: "صغير",
        middle: "متوسطة",
        big: "كبير",
        closePan: "إغلاق لوحة التحديد",
        openPan: "افتح لوحة التحديد",
        reCurrentPage: "إعادة تعيين الصفحة الحالية",
        showPpt: "عرض شرائح",
        generate: "جاري التوليد...",
      },
      linkDialog: {
        url: "الرجاء إدخال عنوان رابط الويب",
        ppt: "عرض الشرائح",
        preView: "معاينة",
        pageUrl: "رابط موقع",
        pptPage: "صفحة الشريحة",
      },
    },
    canvasTool: {
      index: {
        ctrlZ: "تراجع عن",
        reSet: "إعادة",
        text: "إدراج نص",
        horizontal: "مربع نص أفقي",
        vertical: "مربع نص عمودي",
        image: "إدراج صورة",
        shape: "إدراج الشكل",
        line: "إدراج خط",
        chart: "إدراج رسم بياني",
        table: "إدراج جدول",
        gs: "إدراج صيغة",
        voice: "إدراج صوت/فيديو",
        screen: "صالح للشاشة",
        workspase: "مساحة العمل",
        save: "حفظ",
        logo: "إدراج شعار",
        close: "إغلاق PPT",
        share: "يشارك",
        download: "تحميل",
        templateReplacement: "استبدال قالب الشريحة",
      },
      mediaInput: {
        videoUrl: "أدخل عنوان URL للفيديو، مثل https://xxx.mp4",
        voiceUrl: "أدخل عنوان URL للصوت، مثل https://xxx.mp3",
        video: "فيديو",
        voice: "صوت",
        videoError: "الرجاء إدخال عنوان URL الصحيح للفيديو أولاً",
        voiceError: "الرجاء إدخال عنوان URL الصحيح للصوت أولاً",
      },
      tableGenerator: {
        table: "جدول",
        row: "صفوف",
        column: "أعمدة",
        rcError: "يجب أن تكون الصفوف/الأعمدة بين 0 و 20!",
      },
      logo: {
        text1: "تحميل شعار الشركة",
        text2: "أدخل اسم الشركة",
        companyNamePlaceholder: "أدخل اسم شركتك",
        single: "تطبيق صفحة واحدة",
        all: "تطبيق كل الصفحة",
        position: "موضع",
      },
    },
    editorHeader: {
      index: {
        file: "ملف",
        importPptistFile: "استيراد ملف PPTIST",
        importPptxFile: "استيراد ملف PPTX",
        exportPptxFile: "تصدير الملف",
        undo: "تراجع عن",
        redo: "إعادة",
        createSlide: "إضافة صفحة",
        deleteSlide: "حذف الصفحة",
        closeGridLines: "إغلاق خطوط الشبكة",
        openGridLines: "افتح خطوط الشبكة",
        closeRuler: "إغلاق المسطرة",
        openRuler: "حاكم مفتوح",
        resetSlides: "إعادة تعيين الشرائح",
        closeSelectPanel: "إغلاق لوحة التحديد",
        openSelectPanel: "افتح لوحة التحديد",
        f5: "حاضر",
        enterScreeningFromStart: "البدء من البداية",
        enterScreening: "ابدأ من الصفحة الحالية",
        help: "يساعد",
        hotkey: "مفاتيح الاختصار",
        pptShow: "عرض شرائح",
        export: "تصدير",
        importing: "جاري الاستيراد...",
        continue: "اكملى",
        pauseGeneration: "يوقف",
        noPricing: "كن عضواً واستمتع بامتيازات التنزيل معنا.",
        noPricingToOpt: "فتح جميع الامتيازات.",
        getTokens: "ترقية إلى النسخة المحترفة",
        pptSlidesMsg: "تهانينا على إنشاء {0} شرائح PPT كاملة! ",
        Feedback: "دع الذكاء الاصطناعي يكون مساعد عملك.",
        giveAway: "اهداء كوبونات (صالحة لمدة 30 دقيقة)",
        getItNow: "احصل عليها الآن",
        unlockAllPpt: "فتح جميع ميزات PPT",
        grantPermission: "منح الإذن لاستخدام الخريطة الذهنية للذكاء الاصطناعي",
        grantPermissionToUseGpt: "منح إذن استخدام GPT.",
        permissionCodeUse:
          "الرجاء تذكر رمز الخصم والانتقال إلى صفحة الدفع للاستخدام!",
        pptTi1: "لقد أكملت كل العمل وتم إنشاء مجموع {0} صفحة من PPT. ",
        pptTi2:
          "تحتاج فقط الى الخطوة الاخيرة للحصول على ابداع الذكاء الاصطناعي الرائع الخاص بك!",
      },
    },
    exportDialog: {
      tips: "تنزيل PPT غير مدعوم في التطبيق في الوقت الحالي؛ يرجى التنزيل على جهاز الكمبيوتر",
      exportScope: "نطاق التصدير",
      close: "يغلق",
      all: "جميع",
      thisPage: "الصفحه الحاليه",
      auto: "مخصص",
      autoScope: "نطاق مخصص",
      exporting: "جار التصدير...",
      exportImg: "تصدير الصورة",
      expPdf: "طباعة / تصدير PDF",
      expPptx: "تصدير PPTX",
      downloadSuccess: "تمت عملية تحويل الملف بنجاح. يرجى اختيار مسار الحفظ",
      exportImage: {
        exportType: "تصدير الصيغة",
        imageQuality: "جودة الصورة",
        ignoreFont: "تجاهل الخطوط عبر الإنترنت",
        ignoreLineFont:
          "بشكل افتراضي، سيتم تجاهل الخطوط عبر الإنترنت أثناء التصدير. إذا كنت قد استخدمت خطوط عبر الإنترنت في العرض التقديمي وترغب في الاحتفاظ بأنماطها بعد التصدير، يمكنك اختيار إيقاف خيار 'تجاهل الخطوط عبر الإنترنت،' ولكن يرجى ملاحظة أن هذا قد يزيد من وقت التصدير.",
      },
      exportPdf: {
        all: "جميع الشرائح",
        thisPage: "الشريحة الحالية",
        pageNum: "صفحة لكل ورقة",
        white: "هامش الصفحة",
        notice:
          "ملاحظة: إذا لم يتطابق معاينة الطباعة مع النمط الفعلي، يرجى التحقق من خيار 'الرسومات الخلفية' في نافذة الطباعة المنبثقة.",
      },
      exportPPTX: {
        title: "تجاوز الماجستير الافتراضي",
        notice:
          "ملحوظة: بعد التنزيل، يرجى فتحه باستخدام Microsoft Office، حيث قد لا يكون الآخرون متوافقين.",
      },
    },
    remark: {
      remark: "انقر لإدخال ملاحظات المتحدث",
    },
    thumbnails: {
      add: "أضف شريحة",
      slide: "عرض الشرائح",
    },
    toolbar: {
      common: {
        elementColorMask: {
          recolor: "إعادة التلوين (القناع)",
          maskColor: "لون القناع",
          opacity: "العتامة",
        },
        elementFilter: {
          enableFilter: "تمكين الفلاتر",
          blur: "طمس",
          brightness: "سطوع",
          contrast: "التباين",
          grayscale: "تدرج الرمادي",
          saturate: "التشبع",
          hueRotate: "اللون",
          opacity: "العتامة",
        },
        elementFlip: {
          horizontal: "الوجه أفقيا",
          vertical: "الوجه عموديا",
        },
        elementOpacity: {
          opacity: "العتامة",
        },
        elementOutline: {
          border: "تمكين الحدود",
          borderStyle: "نمط الحدود",
          solid: "الحدود الصلبة",
          dashes: "الحدود المتقطعة",
          borderColor: "لون الحدود",
          borderWeight: "وزن الحدود",
        },
        elementShadow: {
          enable: "تمكين الظل",
          horizontal: "الظل الأفقي",
          vertical: "الظل العمودي",
          fuzzyDistance: "طمس المسافة",
          color: "لون الظل",
        },
      },
      panel: {
        background: "تعبئة الخلفية",
        solid: "تعبئة اللون الصلب",
        image: "تعبئة الصورة",
        gradient: "ملء الانحدار",
        contain: "تغيير الحجم",
        repeat: "التصاق",
        cover: "التكبير للتغطية",
        linear: "الخطي التدرج",
        radial: "شعاعي التدرج",
        startColor: "ابدأ اللون",
        endColor: "اللون النهائي",
        rotate: "زاوية التدرج",
        useBackgroundToAll: "تطبيق الخلفية على الكل",
      },
      elementStylePanel: {
        chartStylePanel: {
          chartDataEditor: {
            rowType: "الفئة",
            colType: "سلسلة",
          },
          index: {
            edit: "تحرير بيانات الرسم البياني",
            area: "نمط المخطط المساحي",
            line: "مبعثر نمط الرسم البياني",
            lineSmooth: "استخدم الخط السلس",
            horizontalBars: "نمط الرسم البياني الشريطي",
            stackBars: "مكدسة النمط",
            donut: "نمط مخطط الدونات",
            img: "أسطورة",
            hidden: "لا تظهر",
            showTop: "عرض في الأعلى",
            showBottom: "عرض في الأسفل",
            tabColor: "لون الشبكة",
            labelColor: "لون الخط",
            titleSetColor: "ألوان الموضوع:",
            title: "المواضيع الموصى بها",
            titleColor: "إضافة لون الموضوع",
          },
        },
        audioStylePanel: {
          imgColor: "لون الأيقونة",
          autoPlay: "اللعب التلقائي",
          loopPlay: "تشغيل التكرار",
        },
        imageStylePanel: {
          cutImg: "صورة المحاصيل",
          shape: "حسب الشكل",
          type: "تصنيف",
          preview: "معاينة",
          use: "استخدام",
          searchByType: "البحث حسب الفئة",
          uploadAndReplace: "تحميل الصورة واستبدالها",
          reSetStyle: "إعادة ضبط النمط",
          setBackground: "تعيين كخلفية",
          clip1: "حسب نسبة العرض إلى الارتفاع (مربع)",
          clip2: "حسب نسبة العرض إلى الارتفاع (صورة)",
          clip3: "حسب نسبة العرض إلى الارتفاع (أفقي)",
        },
        latexStylePanel: {
          edit: "تحرير LaTeX",
          color: "لون",
          bold: "عريض",
        },
        lineStylePanel: {
          style: "نمط الخط",
          solid: "خط صلب",
          dotted: "خط منقط",
          color: "لون السطر",
          weight: "عرض الخط",
          startStyle: "أسلوب البداية",
          endStyle: "أسلوب النهاية",
          none: "لا شيء",
          arrow: "سهم",
          dot: "دوت",
        },
        multiStylePanel: {
          colorPicker: "تعبئة اللون",
          style: "نمط الحدود",
          solid: "الحدود الصلبة",
          dotted: "الحدود المنقطة",
          color: "لون الحدود",
          weight: "عرض الحدود",
        },
        shapeStylePanel: {
          replaceShade: "انقر لاستبدال الشكل",
          fill: "ملء اللون الصلب",
          gradient: "ملء التدرجات",
          linear: "تدرج خطي",
          radial: "تدرج شعاعي",
        },
        tableStylePanel: {
          colFull: "تعبئة الخليةl",
          row: "صفوف",
          col: "أعمدة",
          titleRow: "الصف العنواني",
          totalRow: "الصف الإجمالي",
          firstCol: "العمود الأول",
          lastCol: "العمود الأخير",
          titleColor: "لون السمة",
          themeTable: "جدول الموضوع",
        },
        textStylePanel: {
          urlError: "ليس عنوان ويب صحيح",
          command: "قائمة نقطية",
          lineHeight: "تباعد الأسطر",
          times: "مرة",
          paragraphSpace: "تباعد بين الفقرات",
          wordSpace: "تباعد الكلمات",
          textIndent: "المسافة البادئة للسطر الأول",
          textFill: "تعبئة مربع النص",
          title: "عنوان",
          titleSmall: "العنوان الفرعي",
          text: "نص",
          textSmall: "نص [صغير]",
          zs1: "ملاحظة 1",
          zs2: "ملاحظة 2",
        },
        videoStylePanel: {
          cover: "غلاف معاينة الفيديو",
          recover: "إعادة تعيين الغلاف",
        },
      },
      elementAnimationPanel: {
        addEffects: "إضافة الرسوم المتحركة",
        selectAndAddEffects: "تحديد العناصر على اللوحة وإضافة الحركة",
        time: "المدة الزمنية",
        triggerType: "نوع الزناد",
        initiative: "مشغل المبادرة",
        sameTime: "لمست في نفس الوقت كما السابق",
        after: "بعد السابق",
        change: "تغيير الرسوم المتحركة",
        in: "دخول",
        out: "خروج",
        attention: "توكيد",
      },
      elementPositionPanel: {
        layer: "طبقة",
        align: "محاذاة",
        top: "اجلب للمقدمة",
        bottom: "إرسال إلى الخلف",
        up: "تحريك للأمام",
        down: "إرسال للخلف",
        noRixedRatio: "إلغاء قفل نسبة العرض إلى الارتفاع",
        fixedRatio: "قفل نسبة العرض إلى الارتفاع",
      },
      index: {
        style: "أسلوب",
        symbol: "رمز",
        position: "موضع",
        animation: "الرسوم المتحركة",
        design: "تصميم",
        slideAnimation: "الانتقال",
      },
      slideDesignPanel: {
        canvasSize: "حجم قماش",
        wideScreen1: "شاشة عريضة 16:9",
        wideScreen2: "شاشة عريضة 16:10",
        standard: "المعيار 4:3",
        paper: "ورقة A4/A3",
        title: "موضوع عالمي",
        mainColor: "لون السمة",
        useMainToAll: "تطبيق السمة على الكل",
        preMain: "موضوع محدد مسبقا",
        text: "نص Aa",
        use: "تطبيق",
        useToAll: "تطبيق جميع",
      },
    },
    selectPanel: {
      select: "اختيار",
      showAll: "إظهار الكل",
      hideAll: "إخفاء الكل",
      group: "مجموعة",
    },
    redraw: {
      topLabel: "إعادة رسم",
      msgTips: "الرجاء إدخال المحتوى الذي تم إنشاؤه",
      retext: "إعادة رسم",
      cltext: "يلغي",
      btnText: "إنشاء",
      reConfirm:
        "سيؤدي إنشاء هذا إلى استبدال الصفحة الحالية ولن يحفظ المحتوى التاريخي. هل أنت متأكد أنك تريد الاستمرار؟",
      confirmBtnTxt: "اكملى",
    },
  },
  screen: {
    presenter: {
      normalView: "عرض عادي",
      pen: "القلم",
      laserPointer: "مؤشر الليزر",
      timer: "الموقت",
      exitFullScreen: "الخروج من الشاشة الكاملة",
      fullScreen: "تكبير الشاشة",
      endPresentation: "نهاية العرض",
      speakerNotes: "ملاحظات المتحدث",
      speakersView: "محاولة المتحدث",
      previousPage: "الصفحة السابقة",
      nextPage: "الصفحة التالية",
      firstPage: "الصفحة الأولى",
      lastPage: "الصفحة الأخيرة",
      brushTool: "أداة الرسم",
      noRemarks: "بدون ملاحظات",
      lastPageTips: "هذه هي الصفحة الأخيرة بالفعل",
      firstPageTips: "هذه هي الصفحة الأولى بالفعل",
      autoPlay: "ابدأ العرض التلقائي",
    },
    writingBoard: {
      inkThickness: "سمك الحبر",
      eraserSize: "حجم الممحاة",
      eraser: "ممحاة",
      clearInk: "حبر واضح",
      blackboard: "سبورة",
      closeBrush: "أغلق الفرشاة",
    },
  },
  mobile: {
    index: {
      notSupport: "يتم تطوير النسخة المحمولة بشكل عاجل.",
      toPc: "يرجى زيارة الموقع على جهاز الكمبيوتر.",
      editTips: "يرجى التعديل على جهاز الكمبيوتر.",
    },
  },
  useCreateElement: {
    type: "النوع{0}",
    class: "السلسلة{0}",
  },
  components: {
    latexEditor: {
      index: {
        lateX: "LaTeXأدخل صيغة",
        preViw: "معاينة الصيغة",
        symbol: "الرموز الشائعة",
        formula: "الصيغ المحددة مسبقا",
        error: "لا يمكن أن تكون الصيغة فارغة",
      },
    },
    colorPicker: {
      recentUse: "الاستخدام الأخير",
    },
  },
  config: {
    latex: {
      gauss: "صيغة الغاوسية",
      fourierSeries: "سلسلة فورييه",
      taylorExpansion: "توسع تايلور",
      definiteIntegral: "التكامل المحدد",
      trigonometricIdentity1: "الهوية المثلثية 1",
      trigonometricIdentity2: "الهوية المثلثية 2",
      expansion: "توسيع الجمع",
      euler: "صيغة أويلر",
      differential: "معادلة برنولي",
      totalDifferentialEquation: "معادلة التفاضل الكلي",
      homogeneous: "المعادلة غير الهموجيّة",
      cauchy: "نظرية كوشي للقيم المتوسطة",
      lagrange: "نظرية لاجرانج للقيم المتوسطة",
      arcsin: "صيغة المشتقة",
      trigonometric: "تكامل الدوال المثلثية",
      quadric: "سطح ثنائي الترتيب",
      dx: "التفاضل من الدرجة الثانية",
      partial: "المشتق الاتجاهي",
      operators: "الرياضيات",
      group: "تركيبات",
      verbatim: "دالة",
      greek: "الحروف اليونانية",
    },
    symbol: {
      letter: "حرف",
      number: "رقم تسلسلي",
      math: "رقم",
      arrow: "سهم",
      graph: "شكل",
    },
    lines: {
      straight: "خط",
      brokenOrCurve: "خط متقطع أو منحنى",
    },
  },
  hotkey: {
    opt: {
      common: "عام",
      ctrlX: "قص",
      ctrlC: "نسخ",
      ctrlV: "لصق",
      ctrlD: "نسخ ولصق السريع",
      ctrlA: "تحديد الكل",
      ctrlZ: "التراجع",
      ctrlY: "إعادة",
      del: "حذف",
      ctrlMore: "التحديد المتعدد",
      ctrlP: "طباعة",
      esc: "إغلاق النافذة المنبثقة",
    },
    slide: {
      show: "عرض شرائح",
      edit: "تحرير الشريحة",
      first: "بدء عرض الشرائح من البداية",
      current: "بدء عرض الشرائح من الحالي",
      spacePre: "التبديل إلى الصفحة السابقة",
      spaceNext1: "التبديل إلى الصفحة التالية",
      spaceNext2: "التبديل إلى الصفحة التالية",
      out: "الخروج من عرض الشرائح",
      new: "إنشاء شريحة جديدة",
      move: "تحرك كانفاs",
      upOrDown: "تغيير حجم الشريحة",
      up: "تكبير الشريحة",
      down: "تصغير الشريحة",
      screen: "تناسب الشاشة الحالية",
      noSelectPrePage: "الصفحة السابقة (العناصر غيرالمحددة)",
      noSelectNextPage: "الصفحة التالية (العناصر غير المحددة)",
      prePage: "الصفحة السابقة",
      nextPage: "الصفحة القادمة",
    },
    element: {
      opt: "عمليات العناصر",
      move: "تحرك",
      lock: "قفل",
      combo: "تجميع",
      cancelCombo: "إلغاء التجميع",
      top: "وضع في الطبقة العليا",
      bottom: "وضع في الطبقة السفلية",
      h: "قفل نسبة العرض إلى الارتفاع",
      v: "إنشاء خط أفقي / عمودي",
      change: "تبديل عنصر التركيز",
      com: "تأكيد اقتصاص الصورة",
      text: "نص",
      image: "صورة",
      shape: "شكل",
      line: "خط",
      chart: "جدول",
      table: "طاولة",
      video: "فيديو",
      audio: "صوتي",
      latex: "معادلة",
    },
    table: {
      edit: "تحرير الجدول",
      nextCol: "تركيز على الخلية التالية",
      insertTop: "إدراج صف أعلاه",
      insertBottom: "إدراج صف أدناه",
      insertLeft: "قم بإدراج عمود على اليسار",
      insertRight: "قم بإدراج عمود على اليمين",
    },
    chat: {
      edit: "تحرير بيانات الرسم البياني",
      nextLine: "التركيز على السطر التالي",
    },
    text: {
      edit: "تحرير النص",
      bold: "النص المعتمد",
      italics: "النص المائل",
      underline: "الخط السفلي",
      delLine: "الخط العلوي",
    },
  },
  shape: {
    rectangle: "مستطيل",
    commonUse: "الأشكال الشائعة",
    arrow: "سهم",
    other: "أشكال أخرى",
    line: "خط",
  },
  animation: {
    in: {
      bounce: "ارتداد",
      bounceIn: "الظهور",
      bounceInLeft: "الظهور إلى اليمين",
      bounceInRight: "الظهور إلى اليسار",
      bounceInUp: "الظهور إلى الأعلى",
      bounceInDown: "الظهور إلى الأسفل",
      fade: "تلاشي",
      fadeIn: "ظهور تدريجي",
      fadeInDown: "ظهور من الأسفل",
      fadeInDownBig: "ظهور كبير من الأسفل",
      fadeInLeft: "ظهور من اليسار",
      fadeInLeftBig: "ظهور كبير من اليسار",
      fadeInRight: "ظهور من اليمين",
      fadeInRightBig: "ظهور كبير من اليمين",
      fadeInUp: "ظهور من الأعلى",
      fadeInUpBig: "ظهور كبير من الأعلى",
      fadeInTopLeft: "ظهور من الأعلى اليسار",
      fadeInTopRight: "ظهور من الأعلى اليمين",
      fadeInBottomLeft: "ظهور من الأسفل اليسار",
      fadeInBottomRight: "ظهور من الأسفل اليمين",
      rotate: "تدوير",
      rotateIn: "الدوران والظهور",
      rotateInDownLeft: "الدوران والظهور من الأسفل اليسار",
      rotateInDownRight: "الدوران والظهور من الأسفل اليمين",
      rotateInUpLeft: "الدوران والظهور من الأعلى اليسار",
      rotateInUpRight: "الدوران والظهور من الأعلى اليمين",
      zoom: "تكبير/تصغير",
      zoomIn: "التكبير والظهور",
      zoomInDown: "التكبير والظهور من الأسفل",
      zoomInLeft: "التكبير والظهور من اليسار",
      zoomInRight: "التكبير والظهور من اليمين",
      zoomInUp: "التكبير والظهور من الأعلى",
      slide: "الانزلاق والظهور",
      slideInDown: "الانزلاق والظهور من الأسفل",
      slideInLeft: "الانزلاق والظهور من اليسار",
      slideInRight: "الانزلاق والظهور من اليمين",
      slideInUp: "الانزلاق والظهور من الأعلى",
      flip: "اقلب للدخول",
      flipInX: "اقلب حول المحور X للدخول",
      flipInY: "اقلب حول المحور Y للدخول",
      back: "قم بالتمرير والتكبير",
      backInDown: "قم بالتمرير لأسفل للتكبير",
      backInLeft: "التكبير من اليسار والانزلاق للداخل",
      backInRight: "التكبير من اليمين والانزلاق للداخل",
      backInUp: "مرر للأعلى للتكبير",
      lightSpeed: "يطير في",
      lightSpeedInRight: "الطيران والظهور من اليمين",
      lightSpeedInLeft: "الطيران والظهور من اليسار",
    },
    out: {
      bounce: "ارتداد",
      bounceOut: "ينبثق",
      bounceOutLeft: "ينبثق نحو اليسار",
      bounceOutRight: "ينبثق نحو اليمين",
      bounceOutUp: "ينبثق نحو الأعلى",
      bounceOutDown: "ينبثق نحو الأسفل",
      fade: "يظهر",
      fadeOut: "يظهر بتأثير تدرجي",
      fadeOutDown: "يظهر من الأعلى ويتحرك لأسفل",
      fadeOutDownBig: "تطفو للأعلى بمسافة طويلة",
      fadeOutLeft: "الظهور إلى اليسار",
      fadeOutLeftBig: "الظهور باتجاه اليسار بمسافة طويلة",
      fadeOutRight: "الظهور باتجاه اليمين",
      fadeOutRightBig: "الظهور باتجاه اليمين بمسافة طويلة",
      fadeOutUp: "الظهور لأعلى",
      fadeOutUpBig: "الظهور لأعلى بمسافة طويلة",
      fadeOutTopLeft: "الظهور من الجهة اليسارية العليا",
      fadeOutTopRight: "الظهور من الجهة اليمنى العليا",
      fadeOutBottomLeft: "الظهور من الجهة اليسرى السفلى",
      fadeOutBottomRight: "الظهور من الجهة اليمنى السفلية",
      rotate: "دوران ",
      rotateOut: "خروج بتدوير ",
      rotateOutDownLeft: "الخروج بالدوران إلى اليسار السفلي",
      rotateOutDownRight: "الخروج بالدوران إلى اليمين السفلي",
      rotateOutUpLeft: "الخروج بالدوران إلى اليسار العلوي",
      rotateOutUpRight: "الخروج بالدوران إلى اليمين العلوي",
      zoom: "التكبير/التصغير",
      zoomOut: "خروج بالتصغير",
      zoomOutDown: "الخروج بالتصغير للأسفل",
      zoomOutLeft: "الخروج بالتصغير من اليسار",
      zoomOutRight: "الخروج بالتصغير من اليمين",
      zoomOutUp: "الخروج بالتصغير للأعلى",
      slide: "الانزلاق",
      slideOutDown: "الانزلاق للأسفل",
      slideOutLeft: "الانزلاق من اليسار",
      slideOutRight: "الانزلاق من اليمين",
      slideOutUp: "الانزلاق للأعلى",
      flip: "الانعكاس",
      flipOutX: "الخروج بالانعكاس على محور الإكس",
      flipOutY: "الخروج بالانعكاس على محور الواي",
      back: "الانزلاق بالتصغير",
      backOutDown: "الانزلاق بالتصغير للأسفل",
      backOutLeft: "الانزلاق بالتصغير من اليسار",
      backOutRight: "الانزلاق بالتصغير من اليمين",
      backOutUp: "الانزلاق بالتصغير للأعلى",
      lightSpeed: "الطيران",
      lightSpeedOutRight: "الطيران من اليمين",
      lightSpeedOutLeft: "الطيران من اليسار",
    },
    attention: {
      shake: "تهزّ",
      shakeX: "يتأرجح من اليسار إلى اليمين",
      shakeY: "يتأرجح من الأعلى إلى الأسفل",
      headShake: "يهز رأسه",
      swing: "يتأرجح",
      wobble: "يتهادى",
      tada: "يرتعب",
      jello: "جيلي",
      other: "آخر",
      bounce: "يتراقص",
      flash: "يومض",
      pulse: "نبض",
      rubberBand: "مطاط",
      heartBeat: "نبض (بسرعة)",
    },
  },
  requestError: {
    tokenExpires: "فشلت المصادقة، غير قادر على الوصول إلى موارد النظام",
    permissionDenied: "العملية الحالية غير مسموح بها",
    notFound: "الموارد غير موجود",
    default: "خطأ غير معروف في النظام، يرجى إبلاغ المسؤول",
    exceptionReminder: "تذكير بالاستثناء",
    pleaseLogin:
      "الجلسة غير صالحة، أو الجلسة منتهية الصلاحية، يرجى تسجيل الدخول مرة أخرى.",
    networkError: "خطأ في الشبكة",
    requestTimeOut: "انتهت مهلة طلب واجهة النظام",
    requestFailed: "الطلب فشل",
  },
  promptsText: {
    theme: [
      "!استكشاف مواضيع مختلفة واكتشاف متعة لا نهاية لها",
      " !اضغط على صفحة كل موضوع وانطلق في رحلة سحرية",
      "كل موضوع له سحره الفريد، لماذا لا تستكشفها جميعًا؟",
      " !مرحبًا بك في عالم المواضيع، اختر اهتماماتك وابدأ مغامرتك ",
      " !عرض الشرائح الأول من الذكاء الاصطناعي على وشك الوصول، ترقبوا",
      "...انطلق في رحلة عرض الشرائح، والمغادرة وشيكة",
      "...هل أنت مستعد لعيد بصري جديد؟ عرض الشرائح على وشك البدء",
      "...استعدّ! المحطة القادمة، رحلة عرض الشرائح المذهلة",
      "...سريع! أغمض عينيك وانتظر وصول عرض الشرائح المفاجئ",
      "...عالم عرض الشرائح على وشك أن ينفتح أمامك، ترقبوا",
      "...يرجى التحلي بالصبر، فحلم عرض الشرائح على وشك أن يتحقق",
    ],
    directory: [
      "!ابحث عن كل ما تحتاجه في صفحة الدليل",
      "!صفحة الدليل هي كنز التنقل الخاص بك، مما يسهل عليك العثور على ما تحتاجه",
      "!توفر صفحة الدليل خدمات تنقل شاملة، مما يسمح لك بالعثور على أهدافك بسرعة",
      "!لست متأكدا إلى أين تذهب؟ ابحث عن الإلهام والتوجيه على صفحة الدليل",
    ],
    Content: [
      "!في انتظار... الشريحة التالية ستكون ملونة مثل قوس قزح",
      "!رائع! سوف تزدهر الشريحة التالية مثل الألعاب النارية، وستتركك مندهشًا",
      "!تحلى بالصبر، فالشريحة التالية ستكون رائعة مثل انتظار ظهور قوس قزح حالم",
      "!اشعر بسحر الانتظار! الشريحة التالية سوف تضيء عينيك",
      "!ابقوا متابعين! ستجلب لك الشريحة التالية وليمة بصرية مفاجئة",
      "!سرعة! اسحب الستارة، واستعد لاستقبال الضوء المذهل للشريحة التالية",
      "!إستعد! الشريحة التالية ستجلب عاصفة بصرية جديدة",
      "!فضولك على وشك أن يكون راضيا! الشريحة التالية ستفاجئك",
      "!في انتظار... الشريحة التالية ستأخذك في رحلة بصرية رائعة",
      "!لا تستطيع الانتظار؟ ستكون الشريحة التالية مثيرة مثل الاحتفال الكبير",
      "...تخمين ما ستكون الشريحة التالية؟ الإجابة على وشك الكشف",
      "...يرجى ربط أحزمة الأمان، نحن على وشك الانطلاق إلى الشريحة التالية",
      "...السعادة قادمة! الشريحة التالية تتجه نحوك بسرعة",
      "...خمن اللون الذي ستكون عليه الشريحة التالية. الجواب على وشك أن ينكشف",
      "...رائع! الشريحة التالية ستجلب لك مفاجآت غير متوقعة",
      "...حريصٌ على التجربة؟ الشريحة التالية سترضي فضولك",
      "...في انتظار...الشريحة القادمة ستحمل لكم الفرحة والمفاجآت",
      "!الانتظار... تمامًا مثل انتظار فنجان قهوة لذيذ، الشريحة التالية ستسعد مزاجك",
      "...أغمض عينيك، وعد إلى ثلاثة، فالشريحة التالية ستجلب لك المفاجآت! 1...2...3",
      "!في المغامرة! إن انتظار الشريحة التالية أمر مثير مثل اكتشاف الكنز",
      "!هل أنت جاهز؟ الشريحة التالية ستأخذك في مغامرة رائعة",
    ],
    Comprehensive: [
      "!شيئًا فشيئًا، استكشف عالم المرح الذي لا نهاية له",
      "!من المواضيع إلى الدلائل، ثم إلى صفحات المحتوى، كل خطوة هي رحلة اكتشاف",
      "!لنبدأ معًا في رحلة رائعة، نترك بصماتنا في هذا العالم المثير",
      "!في هذا الموقع المدهش، دعونا نكتشف المزيد معًا",
    ],
    Unpurchased: [
      "متحمس للمحاولة؟ ستبدأ الشريحة التالية بعرض مرئي، انضم إلينا!",
      "!أكثر من مجرد منتجات، إنها طريقة حياة! انقر للشراء واترك مزاجك يطير",
      "!هنا، أنت لا تشتري المنتجات فحسب، بل تشتري السعادة بكثرة أيضًا",
      "!انضم كعضو وابدأ فصلاً جديدًا من الحياة المبهجة",
      "!انقر للشراء واجعل كل يوم مليئًا بالمفاجآت والمرح",
      "!الشراء أكثر من مجرد فعل، إنه طريقة للاستمتاع بالحياة",
      "!اغتنم الفرصة، وقم بشراء المنتجات التي تريدها، واجعل الحياة أكثر سخونة",
      "!الشراء مغامرة رائعة، لننطلق في هذه الرحلة معًا",
      "!انقر للشراء، واحصل على مفاجأة وسعادة لنفسك",
      "!الشراء هو تعبير، دعونا نختار مع القلب معًا",
    ],
  },
};
